import { useAuthContext } from "@/auth/AuthProvider";
import { useLastRefreshed } from "./useLastRefreshed";

export function Footer() {
  const { isAuthenticated, user } = useAuthContext();
  const userGroup = user?.groups.find(
    (group) => group.id === user.activeGroupId,
  )?.name;
  const lastRefreshed = useLastRefreshed();

  return (
    <footer className="flex flex-row justify-between w-full py-2 px-[50px] bg-blue-200 shadow-[0_-2px_8px_0_rgba(0,0,0,0.1)]">
      <div className="flex-1">
        <p className="text-sm text-muted-foreground font-normal">
          ©COR STP Solutions Limited 2026. All rights reserved.
        </p>
      </div>
      {isAuthenticated && (
        <div className="flex flex-row justify-between gap-12">
          <div className="flex flex-row gap-[10px] items-center text-sm">
            <span className="material-symbols-outlined text-lg leading-none">
              account_circle
            </span>
            <p className="text-muted-foreground">User Group</p>
            <p className="text-black">{userGroup}</p>
          </div>
          <div className="flex flex-row gap-[10px] items-center text-sm">
            <span className="material-symbols-outlined text-lg leading-none">
              refresh
            </span>
            <p className="text-black-secondary text-muted-foreground">
              Last Refreshed
            </p>
            <p className="text-black w-20">{lastRefreshed}</p>
          </div>
        </div>
      )}
    </footer>
  );
}
